import { Injectable } from '@angular/core';
import { GridUser } from '../../models/grid-user';
import { UserStatus } from '../../../../../core/models/user-status';
import { User } from '../../models/user';
import { UserRoleLabelMapping } from '../../../../../core/enums/users/role';
import {
    UserMembershipStatus,
    UserMembershipStatusActiveLabels,
    UserMembershipStatusLabelMapping,
    ActiveUserMembershipStatuses,
} from '../../../../../core/enums/users/membership-status';
import { UserRegistration } from '../../../registration/registration/models/user-registration';
import { PhoneNumberService } from '../../../../../core/services/phone-number/phone-number.service';
import { formatToDate } from '../../../../../core/functions/date-helpers';

@Injectable({
    providedIn: 'root',
})
export class UserInformationService {
    constructor(private readonly phoneNumberService: PhoneNumberService) {}

    public getLastName(gridUserObject: GridUser): string {
        let lastName: string | undefined;
        if (
            UserStatus.getUserStatus(gridUserObject.user) ===
                UserStatus.PENDING ||
            UserStatus.getUserStatus(gridUserObject.user) ===
                UserStatus.REJECTED
        ) {
            lastName = gridUserObject.userRegistration?.lastName;
        } else {
            lastName = gridUserObject.userExtension?.lastName;
        }

        return lastName ?? '';
    }

    public getFirstName(gridUserObject: GridUser): string {
        let firstName: string | undefined;
        if (
            UserStatus.getUserStatus(gridUserObject.user) ===
                UserStatus.PENDING ||
            UserStatus.getUserStatus(gridUserObject.user) ===
                UserStatus.REJECTED
        ) {
            firstName = gridUserObject.userRegistration?.firstName;
        } else {
            firstName = gridUserObject.userExtension?.firstName;
        }

        return firstName ?? '';
    }

    public getFullName(gridUserObject: GridUser): string {
        return `${this.getFirstName(gridUserObject)} ${this.getLastName(gridUserObject)}`;
    }

    public getLastLoginDate(user: User): Date | null {
        if (!user.isApproved || !user.lastAccess) {
            return null;
        }

        return formatToDate(user.lastAccess);
    }

    public getRoleLabel(user: User) {
        if (
            UserStatus.getUserStatus(user) === UserStatus.PENDING ||
            UserStatus.getUserStatus(user) === UserStatus.REJECTED
        ) {
            return 'None';
        }

        return UserRoleLabelMapping[user.role];
    }

    public isActiveUserMembershipStatus(
        userMembershipStatus?: UserMembershipStatus | null,
    ): boolean {
        if (!userMembershipStatus) {
            return false;
        }

        return ActiveUserMembershipStatuses.includes(userMembershipStatus);
    }

    public getMembershipStatusLabel(
        userMembershipStatus?: UserMembershipStatus | null,
    ) {
        if (!userMembershipStatus) {
            return UserMembershipStatusActiveLabels.inactive;
        }

        return UserMembershipStatusLabelMapping[userMembershipStatus];
    }

    public getPhoneNumber(userRegistration?: UserRegistration): string {
        if (!userRegistration?.phoneNumber) {
            return '';
        }

        return this.phoneNumberService.buildPhoneNumberString(
            userRegistration.phoneNumber,
            userRegistration.phoneNumberExtension,
        );
    }
}
